import React from 'react';
import { activityNeutralButtonClass } from 'features/activity/styles/dataTableStyles';

/**
 * The floating bar over the bottom of a list page when rows are ticked: the count,
 * the actions, Clear. Render it as the last child of the page's flex column,
 * after the scrolling area, so it floats at the bottom of the page, sized to its content. Each action
 * is { label, onClick, disabled?, danger? }; anything else (e.g. a menu
 * button) goes in `children`.
 */
export default function BulkBar({ count, label = 'Selected rows', actions = [], onClear, children }) {
  if (!count) return null;
  return (
    <div className="pointer-events-none relative z-20 h-0 shrink-0">
      <div className="pointer-events-auto absolute bottom-4 left-1/2 flex w-max max-w-[calc(100%-2rem)] -translate-x-1/2 flex-wrap items-center gap-2 rounded-lg border border-[color:var(--border-default)] bg-[color:var(--surface-raised)] px-3 py-2 shadow-token-lg" role="group" aria-label={label}>
        <span className="mr-1 text-[12px] font-medium tabular-nums text-[color:var(--text-primary)]">{count} selected</span>
        {actions.map((a) => (
          <button key={a.label} type="button" disabled={a.disabled} onClick={a.onClick} title={a.title}
            className={`${activityNeutralButtonClass}${a.danger ? ' hover:text-danger' : ''}`}>{a.label}</button>
        ))}
        {children}
        <button type="button" onClick={onClear} className="h-8 rounded-md px-2 text-[12px] text-[color:var(--text-muted)] hover:bg-surface-hover">Clear</button>
      </div>
    </div>
  );
}
